export class FormSchemaModel {
    constructor(
        public background: string | ArrayBuffer = '',
        public form: any = null,
        public tags: any = null,
        public text: string = '',
        public title: string = ''
    ) {}
}
